module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('algorithm-tabs', {
    ref: "tabAlgorithms",
    staticClass: "negative-margin",
    attrs: {
      "selectedAlgorithm": _vm.selectedSubTab,
      "mini": true,
      "localAlgorithms": _vm.listOfAlgorithms
    },
    on: {
      "selected": _vm.changeSubTab
    }
  }), _vm._l((_vm.listOfAlgorithms), function(item) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedSubTab.code === item.code),
        expression: "selectedSubTab.code === item.code"
      }],
      staticClass: "info-miner w100 subtab"
    }, [
      [(item.hasNoWorkers) ? _c('div', {
        staticClass: "table-workers-0 feature-helvetica has-text-centered"
      }, [_c('br'), _c('span', [_vm._v("You have no " + _vm._s(item.name) + " workers online.")]), _vm._m(0, true), _c('div', {
        staticClass: "mt-10"
      }, [_c('span', [_vm._v("You can also check ")]), _c('router-link', {
        staticClass: "info-link",
        attrs: {
          "to": "/support"
        }
      }, [_vm._v("our support center")]), _c('span', [_vm._v(" or try ")]), _c('router-link', {
        staticClass: "info-link",
        attrs: {
          "to": "/wizard"
        }
      }, [_vm._v("our wizard 🧙‍♂️")]), _c('span', [_vm._v(" for getting started")])], 1)]) : _vm._e(), (!item.hasNoWorkers) ? _c('div', {
        staticClass: "columns"
      }, [_c('div', {
        staticClass: "column"
      }, [(item.showGraph) ? _c('ChartHashrate', {
        attrs: {
          "options": item.chartOptions,
          "series": item.chartSeries,
          "preUnit": item.preUnitOfMeasurement,
          "minimumUnit": item.minimumUnitOfMeasurement
        }
      }) : _vm._e()], 1), _c('div', {
        staticClass: "column"
      }, [_c('table', {
        staticClass: "table is-fullwidth table-workers"
      }, [_c('thead', [_c('tr', [_vm._m(1, true), _c('th', {
        staticClass: "has-text-right column-100"
      }, [(item.hasReportedHashrate) ? _c('div', {
        staticClass: "hint--top-left hint--large has-text-left cursor-pointer",
        attrs: {
          "aria-label": "Current & (Calculated) hash rate, based on submitted shares, your calculated (effective) hr may take up to an hour get on par with your Current (reported) hash rate, depending on your mining stability. Current hash rate is informative, calculated hash rate is used for rewards."
        }
      }, [_c('span', [_vm._v("Speed")]), _c('i', {
        staticClass: "fa fa-info-circle ml-5"
      })]) : _c('div', [_c('span', [_vm._v("Speed")])])])])]), _c('tbody', _vm._l((item.workers), function(o) {
        return _c('tr', {
          class: {
            'offline': !o.online
          }
        }, [_c('td', [_c('span', [_vm._v(_vm._s(o.name))]), (o.referral) ? [_c('div'), _c('span', {
          staticClass: "referral_code_lbl hint--right",
          attrs: {
            "aria-label": "Referral Code"
          }
        }, [_vm._v(_vm._s(o.referral))])] : _vm._e()], 2), _c('td', {
          staticClass: "has-text-right"
        }, [(item.hasReportedHashrate) ? [_c('span', [_vm._v(_vm._s(o.transformedRhr) + " " + _vm._s(_vm._f("capitalize")(o.transformedUnitRhr)) + "/s ")]), _c('span', {
          staticClass: "opacity-07"
        }, [_c('span', [_vm._v("(")]), _c('span', [_vm._v(_vm._s(o.transformedChr) + " " + _vm._s(_vm._f("capitalize")(o.transformedUnitChr)) + "/s")]), _c('span', [_vm._v(")")])])] : [_c('span', [_vm._v(_vm._s(+o.transformedChr || +o.transformedRhr) + " " + _vm._s(_vm._f("capitalize")(o.transformedUnitChr)) + "/s")])]], 2)])
      }), 0)]), _vm._m(2, true)])]) : _vm._e()]
    ], 2)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10"
  }, [_c('span', [_vm._v("If you are sending valid shares, ")]), _c('br'), _c('span', [_vm._v("kindly wait some minutes for your workers to show up.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', [_vm._v("Worker")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-left"
  }, [_c('span', [_vm._v("Please note that your hash rate is based on your worker's past hour performance. It will stabilize ")]), _c('i', [_vm._v("after an hour of continuous mining")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02a1a925","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_workers.vue
// module id = 354
// module chunks = 1